
// Getter Object for ContractsRoyalty. Use it by calling mapGetters from the Vuex Host Components.

export const contractsRoyaltyGetters = {
  contractsRoyaltyData: (state) => state.contractsRoyaltyData,
  contractsList: (state)=> state.contractsList,
  contractsDetails: (state)=> state.contractsDetails,
  display_auto_balance_subtab: (state)=> state.display_auto_balance_subtab,
  display_contract_deductions_subtab: (state)=> state.display_contract_deductions_subtab,
}


